// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2r26O","content":"styles_content__35XjP","selectAll":"styles_selectAll__2CpyW"};